import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import { Table, Button } from "antd";

import { all as AllUsers } from "../../api/User.js";

import { formatFirstname, formatLastname } from '../../utils';

import { ROLES } from "./constants";

const UserTable = forwardRef((props, ref) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [{
    title: "Prénom",
    dataIndex: "firstname",
    render: (data) => formatFirstname(data),
    sorter: true,
    width: "20%",
  }, {
    title: "Nom",
    dataIndex: "lastname",
    render: (data) => formatLastname(data),
    sorter: true,
    width: "20%",
  }, {
    title: "Email",
    dataIndex: "email",
    sorter: true,
  }, {
    title: "Rôle",
    dataIndex: "role_id",
    sorter: true,
    render: (data) => {
      let user_role = ROLES.find((role) => role.id === data);
      if (user_role === undefined) return "";
      return user_role.label;
    }
  }, {
    render: (data) => {
      return (
        <Button
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
          size="large"
          onClick={() => props.onEdit(data.id)}
        ></Button>
      );
    },
    width: "30px",
  }];

  let getParams = (pagination, sorter) => {
    let params = {
      current: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (sorter !== undefined && sorter.column !== undefined) {
      let { field, order } = sorter;
      order = (order === 'ascend') ? 1 : -1;

      if (!!field && !!order) {
        params['sort'] = field + "," + order;
      }
    }

    return params;
  };

  let fetch = async function (pagination, filters, sorter) {
    setLoading(true);

    let params = getParams(pagination, sorter);
    AllUsers(params)
      .then((data) => {
        setData(data.results);
        setPagination({
          ...pagination,
          total: data.total,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch(pagination);
  }, []);

  useImperativeHandle(ref, () => ({
    fetch: () => {
      fetch(pagination);
    },
  }));

  return (
    <Table
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        position: ["topRight"],
      }}
      loading={loading}
      onChange={fetch}
    />
  );
});

export default UserTable;
